module.exports = __webpack_public_path__ + "img/home_btn.c9bbc75e.png";